import React, { useState, useEffect, useContext } from 'react'
import { Form, Toast } from 'antd-mobile';
import dayjs from 'dayjs'
import moment from 'moment';
import { UserContext } from 'utils/getContext'
import { submitForm } from "api/api";
import { getAreaObj, getUserObj, getSkillObj, getPostObj, getFJJobWantedObj, guid } from 'utils/getData'
import { judgeSex, userInfoHide, idCardHide, infoCardType } from "utils/ruleType";
import { transformDate } from 'utils'
import { declarationPage1, declarationPage2, declarationPage3 } from 'data/declarationForm';
import { GetFormType } from "./GetFormType";
import { FromSteps } from "./FromSteps";

/** 失业登记 */
export function Declaration() {
  const myContext = useContext(UserContext)
  const { userInfo } = myContext
  const { name, sex, birthday, idNum } = userInfo ? userInfo : {}
  const [formId, setFormId] = useState('');
  const [form] = Form.useForm();
  const [postData, setPostData] = useState({})
  const [content, setContent] = useState({});
  const [stepNum, setStepNum] = useState(1)
  const [areaContent, setAreaContent] = useState([])
  const [skillContent, setSkillContent] = useState([])
  const [postContent, setPostContent] = useState([])
  const [jobWantContent, setJobWantContent] = useState([])
  const title = ['申请人信息', '失业信息', '求职信息', '提交申请',]
  const pageData = [declarationPage1, declarationPage2, declarationPage3]

  const today = dayjs().format('YYYY-MM-DD')

  /** 对发出的参数数据【postInfo】进行处理 */
  const postInfo = userInfo && {
    ...postData,
    FNAME: name,
    FSEX: sex,
    FCERCAT: infoCardType(userInfo.CARD_TYPE),
    FIDNum: idNum,
    // FBIRTH: birthday,
    FTYPE: 41,
    FORMID: formId, // 上传表单ID
    FREGISTERDATE: today,
  }

  /** 初始化数据 */
  useEffect(() => {
    getAreaObj('', areaContent, setAreaContent)
    getFJJobWantedObj('', jobWantContent, setJobWantContent)
    getSkillObj('', '', skillContent, setSkillContent)
    getPostObj('', '', postContent, setPostContent)
    //获取表单ID
    const date = dayjs().format('YYYYMMDDHHmmss');
    setFormId(date + guid());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** 对默认返回的参数进行处理后显示到页面上 */
  useEffect(() => {
    if (userInfo) {
      form.setFieldsValue({
        FNAME: idCardHide(name, 1, name.length - 1) || '',
        FSEX: judgeSex(sex),
        FCERCAT: '居民身份证',
        FIDNum: userInfoHide(userInfo),
        FBIRTH: transformDate(birthday),
        FREGISTERDATE: today
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [birthday, sex, name, form, userInfo, idNum]);

  /** 更新提交表单接口参数数据 */
  function setFormInfo(name, value) {
    const newPostData = { ...postData }
    newPostData[name] = value
    setPostData(newPostData)
  }

  /**提交表单*/
  async function handleSubmitFormClick(setLoading) {
    if (stepNum < title.length - 1) {
      setStepNum(stepNum + 1)
    }
    if (stepNum === title.length - 1) {
      setLoading(true)
      // T_PSM_UnempRgt
      const newPostInfo = {
        ...postInfo,
        FGRADTIME: moment(postInfo.FGRADTIME).format('YYYYMM'),
        FBIRTH: moment(postInfo.FBIRTH).format('YYYY-MM-DD'),
      }
      // const res = await submitForm(newPostInfo);
      // if (res.code === 200) {
      //   setStepNum(stepNum + 1)
      // } else {
      //   Toast.show({
      //     icon: 'fail',
      //     content: '提交失败，请检查内容并重试',
      //   })
      // }
      try {
        const res = await submitForm(newPostInfo);
        if (res.code === 200) {
          setStepNum(stepNum + 1)
        } else {
          Toast.show({
            icon: 'fail',
            content: '提交失败，请检查内容并重试',
          })
        }
      } catch (error) {
        Toast.show({
          icon: 'fail',
          content: '提交失败，请检查内容并重试',
        })
      } finally {
        setLoading(false)
      }
    }
  }

  /** 初始化表单渲染模板 */
  const getType = (arr, index) =>
    <GetFormType
      form={form}
      key={index}
      item={arr}
      setFormInfo={setFormInfo}
      content={content}
      setContent={setContent}
      getUserObj={getUserObj}
      areaContent={areaContent}
      setAreaContent={setAreaContent}
      getAreaObj={getAreaObj}
      skillContent={skillContent}
      setSkillContent={setSkillContent}
      getSkillObj={getSkillObj}
      getPostObj={getPostObj}
      postContent={postContent}
      setPostContent={setPostContent}
      jobWantContent={jobWantContent}
      setJobWantContent={setJobWantContent}
      getJobWantedObj={getFJJobWantedObj}
      postInfo={postInfo}
      formId={formId}
    />

  return (
    <FromSteps
      stepNum={stepNum} title={title}
      getType={getType} setStepNum={setStepNum}
      form={form} pageData={pageData}
      handleSubmitFormClick={handleSubmitFormClick}
    />
  )
}